module.exports = __webpack_public_path__ + "static/img/partner-logo-16.9159e381.png";